export default __webpack_public_path__ + "d481e269c0d3d20c29a240f37aebe1c6.png";